import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import Logout from './views/Logout.vue'
import Home from './views/Home.vue'
import Maps from './views/Maps.vue'
import Building from './views/Building.vue'
import Experimental from './views/Experimental.vue'
import About from './views/About.vue'
import Reports from './views/Reports.vue'
import DataWarehouse from './views/DataWarehouse.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // {
    //   path: '/page/:code',
    //   name: 'access-page',
    //   component: AccessPage
    // },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/maps',
      name: 'maps',
      component: Maps
    },
    {
      path: '/building',
      name: 'building',
      component: Building
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/data-warehouse',
      name: 'data-warehouse',
      component: DataWarehouse
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout
    },
    {
      path: '/experimental',
      name: 'experimental',
      component: Experimental
    },
    {
      path: '/reports',
      name: 'reports',
      component: Reports
    },
    {
      path: '/',
      name: 'debug',
      component: Login
    },
    {
      path: '*',
      name: 'catchall',
      component: About
    }   
  ]  
})
